// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"41":"ProposalsPage","106":"ProposalPage","415":"WalletPage","750":"TreasuryPage"}[chunkId] + "." + {"41":"46c0bd88","106":"7527b0b6","415":"69f96edf","750":"8eebcec2"}[chunkId] + ".js";
};